import axios from './request'

const URL = {
  // 当日委托
  DelegatedInquiry: {
    retrieve: '/CONTINUTIY-SERVICE/ucentrust/querySimpleEntrust.magpie',
  },
  // 历史委托
  HistoricalDelegatedInquiry: {
    retrieve: '/CONTINUTIY-SERVICE/ucentrust/querySimpleEntrustHis.magpie',
  },
  // 当日套利委托
  ArbitrageInquiry: {
    retrieve: '/CONTINUTIY-SERVICE/ucentrust/queryTlEntrust.magpie',
  },
  // 历史套利委托
  HistoricalArbitrageInquiry: {
    retrieve: '/CONTINUTIY-SERVICE/ucentrust/queryTlEntrustHis.magpie',
  },
  // 当日成交汇总
  Transactioninquiry: {
    retrieve: '/CONTINUTIY-SERVICE/ucmatch/queryCurrentMatchSum.magpie',
  },
  // 当日成交详情
  TransactionXQ: {
    retrieve: '/CONTINUTIY-SERVICE/ucmatch/queryMatchDetail.magpie'
  },
  // 历史成交汇总
  HistoricalTransactioninquiry: {
    retrieve: '/CONTINUTIY-SERVICE/ucmatch/queryHisMatchSum.magpie',
  },
  // 历史成交详情
  HistoricalTransactionXQ: {
    retrieve: '/CONTINUTIY-SERVICE/ucmatch/queryHisMatchDetail.magpie'
  },
  // 当日成交明细
  TransactionDetail: {
    retrieve: '/CONTINUTIY-SERVICE/ucmatch/queryCurrentMatchDetailList.magpie',
  },
  // 历史成交明细
  HistoricalTransactionDetail: {
    retrieve: '/CONTINUTIY-SERVICE/ucmatch/queryHisMatchDetailList.magpie',
  },
  // 当日套利成交汇总
  ArbitrageTransactionInquiry: {
    retrieve: '/CONTINUTIY-SERVICE/ucmatch/queryCurrentTlMatchSum.magpie',
  },
  // 当日套利成交详情
  ArbitrageTransactionDetail: {
    retrieve: '/CONTINUTIY-SERVICE/ucmatch/queryTlMatchDetail.magpie'
  },
  // 历史套利成交汇总
  HistoricalArbitrageTransactionInquiry: {
    retrieve: '/CONTINUTIY-SERVICE/ucmatch/queryHisTlMatchSum.magpie',
  },
  // 历史套利成交详情
  HistoricalArbitrageTransactionDetail: {
    retrieve: '/CONTINUTIY-SERVICE/ucmatch/queryHisTlMatchDetail.magpie'
  },
  // 当日套利成交明细
  ArbitrageTransactionDetailInquiry: {
    retrieve: '/CONTINUTIY-SERVICE/ucmatch/queryCurrentTlMatchDetailList.magpie',
  },
  // 历史套利成交明细
  HistoricalArbitrageTransactionDetailInquiry: {
    retrieve: '/CONTINUTIY-SERVICE/ucmatch/queryHisTlMatchDetailList.magpie',
  },
  // 当日订货汇总
  OrderInquiry: {
    retrieve: '/CONTINUTIY-SERVICE/ucposition/queryPositionPage.magpie',
  },
  // 当日订货详情/当日套利订货详情
  OrderXQ: {
    retrieve: '/CONTINUTIY-SERVICE/ucposition/queryPositionDetail.magpie'
  },
  // 历史订货汇总
  HistoricalOrderInquiry: {
    retrieve: '/CONTINUTIY-SERVICE/ucposition/queryPositionHisPage.magpie',
  },
  // 历史订货详情/历史套利订货详情
  HistoricalOrderXQ: {
    retrieve: '/CONTINUTIY-SERVICE/ucposition/queryHisPositionDetail.magpie'
  },
  // 当日订货明细
  OrderDetailInquiry: {
    retrieve: '/CONTINUTIY-SERVICE/ucposition/queryDetailForTotal.magpie',
  },
  // 历史订货明细
  HistoricalOrderDetailInquiry: {
    retrieve: '/CONTINUTIY-SERVICE/ucposition/queryPositionHisDetail.magpie',
  },
  // 当日套利订货汇总
  ArbitrageOrderInquiry: {
    retrieve: '/CONTINUTIY-SERVICE/ucposition/queryTlPositionPage.magpie',
  },
  // 历史套利订货汇总
  HistoricalArbitrageOrderInquiry: {
    retrieve: '/CONTINUTIY-SERVICE/ucposition/queryTlPositionHisPage.magpie',
  },
  // 当日套利订货明细
  ArbitrageOrderDetailInquiry: {
    retrieve: '/CONTINUTIY-SERVICE/ucposition/queryTlDetailForTotal.magpie',
  },
  // 历史套利订货明细
  HistoricalArbitrageOrderDetailInquiry: {
    retrieve: '/CONTINUTIY-SERVICE/ucposition/queryTlPositionHisDetail.magpie',
  },
  // 交收汇总
  SettlementInquiry: {
    retrieve: '/CONTINUTIY-SERVICE/ucdeliveryGoods/queryDeliverySum.magpie',
  },
  // 交收汇总详情
  SettlementXQ: {
    retrieve: '/CONTINUTIY-SERVICE/ucdeliveryGoods/queryDeliverySumDetail.magpie'
  },
  // 历史交收汇总
  HistoricalSettlementInquiry: {
    retrieve: '/CONTINUTIY-SERVICE/ucdeliveryGoods/queryHisDeliverySum.magpie',
  },
  // 历史交收汇总详情
  HistoricalSettlementXQ: {
    retrieve: '/CONTINUTIY-SERVICE/ucdeliveryGoods/queryHisDeliverySumDetail.magpie'
  },
  // 交收明细
  SettlementDetailInquiry: {
    retrieve: '/CONTINUTIY-SERVICE/ucdeliveryGoods/queryDeliveryDetailList.magpie',
  },
  // 历史交收明细
  HistoricalSettlementDetailInquiry: {
    retrieve: '/CONTINUTIY-SERVICE/ucdeliveryGoods/queryHisDeliveryDetailList.magpie',
  },
  // 沐甜迁移
  GoodsPayment: {
    getToken: '/DATA-FORWARD-SERVER/count/getAccessToken.magpie', // 获取token
    getAllCompany: '/DATA-FORWARD-SERVER/count/getAllCompany.magpie', // 获取所有主体列表
    transactData: '/DATA-FORWARD-SERVER/count/transactData.magpie', // 交收办理查询
    getReceiptData: '/DATA-FORWARD-SERVER/count/receiptData.magpie', // 到期/提前交收通知单
    dailyStatementDataList: '/DATA-FORWARD-SERVER/count/loanAccountData.magpie', // 货款账户日报表
    withholdingPayment: '/DATA-FORWARD-SERVER/count/paymentAccountData.magpie', // 货款账户暂扣款项表
    paymentList: '/DATA-FORWARD-SERVER/count/loanAccountInData.magpie', // 货款账户
  },
  // 交易费用
  TransactionCostInquiry: {
    retrieve: '/CT-REPORT-SERVER/fund/tradeReport.magpie', // 包含当日、历史
  },
  // 盈亏明细
  HreakevenDetailsInquiry: {
    retrieve: '/CT-REPORT-SERVER/ucprofit/queryProfitReport.magpie',
  },
  // 历史盈亏明细
  HistoricalHreakevenDetailsInquiry: {
    retrieve: '/CT-REPORT-SERVER/ucprofit/queryHisProfitReport.magpie',
  },
  // 购销计划一览表-当日行情表
  DailyQuotationSheet: {
    retrieve: '/CONTINUTIY-SERVICE/ucreport/quotationList.magpie',
  },
  // 基本担保履约资金帐户日报表
  DailyStatementOfCapitalAccount: {
    retrieve: '/CONTINUTIY-SERVICE/ucreport/fundList.magpie',
  },
  // 成交汇总
  TransactionSummary: {
    retrieve: '/CONTINUTIY-SERVICE/ucreport/matchTotalList.magpie',
  },
  // 成交明细
  TransactionDetails: {
    retrieve: '/CONTINUTIY-SERVICE/ucreport/matchDetailList.magpie',
  },
  // 套利成交明细
  ArbitrageTransactionDetails: {
    retrieve: '/CONTINUTIY-SERVICE/ucreport/matchArbitrageList.magpie',
  },
  // 订货汇总
  OrderSummary: {
    retrieve: '/CONTINUTIY-SERVICE/ucreport/positionTotalList.magpie',
  },
  // 订货明细
  OrderDetail: {
    retrieve: '/CONTINUTIY-SERVICE/ucreport/positionDetailList.magpie',
  },
  // 套利订货明细
  ArbitrageOrderDetail: {
    retrieve: '/CONTINUTIY-SERVICE/ucreport/positionArbitrageList.magpie',
  },
  // 当日按购销计划查订货
  QueryGoodsCodeCurrentPositions: {
    retrieve: '/CONTINUTIY-SERVICE/ucreport/queryGoodsCodeCurrentPositions.magpie'
  },
  // 历史按购销计划查订货
  QueryGoodsCodeHisPositions: {
    retrieve: '/CONTINUTIY-SERVICE/ucreport/queryGoodsCodeHisPositions.magpie'
  },
  // 月成交汇总
  MonthlyClosingSummary: {
    retrieve: '/CONTINUTIY-SERVICE/ucreport/monthlyMatchHisList.magpie'
  },
  // 月持仓汇总查询
  MonthlyPositionSummary: {
    retrieve: '/CONTINUTIY-SERVICE/ucreport/monthlyPositionList.magpie'
  },
  // 月历史诚意金查询
  MonthlyHistoricalSincerityGold: {
    retrieve: '/CONTINUTIY-SERVICE/ucreport/monthlyFundHisList.magpie'
  },
  // 查询用户当前市场信息
  MarketInfo: {
    retrieve: '/CONTINUTIY-SERVICE/uccommon/queryUserMarketList.magpie'
  },
  // 月报表导出
  MonthlyReportExport: {
    retrieve: '/CONTINUTIY-SERVICE/ucreport/monthlyDataExcel.magpie'
  },
  // 购销计划一览表导出
  PurchaseSaleListExport: {
    retrieve: '/CONTINUTIY-SERVICE-tsg/ucreport/salePlanDataExcel.magpie'
  },
  // 交易日
  SelTradeDate: {
    retrieve: '/CT-REPORT-SERVER/common/selTradeDate.magpie'
  }
}

class SpotPurchaseSale {
  /**
   * 当日委托
   * @param {object} params
   */
  DelegatedInquiry (params) {
    const url = URL.DelegatedInquiry.retrieve

    return axios.post(url, params)
  }
  /**
   *历史委托
   * @param {*} params
   */
  HistoricalDelegatedInquiry (params) {
    const url = URL.HistoricalDelegatedInquiry.retrieve

    return axios.post(url, params)
  }
  /**
   *当日套利委托
   * @param {*} params
   */
  ArbitrageInquiry (params) {
    const url = URL.ArbitrageInquiry.retrieve

    return axios.post(url, params)
  }
  /**
   *历史套利委托
   * @param {*} params
   */
  HistoricalArbitrageInquiry (params) {
    const url = URL.HistoricalArbitrageInquiry.retrieve

    return axios.post(url, params)
  }

  /**
   *当日成交汇总
   * @param {*} params
   */
  Transactioninquiry (params) {
    const url = URL.Transactioninquiry.retrieve

    return axios.post(url, params)
  }
  /**
   *当日成交详情
   * @param {*} params
   */
  TransactionXQ (params) {
    const url = URL.TransactionXQ.retrieve

    return axios.post(url, params)
  }
  /**
   *历史成交汇总
   * @param {*} params
   */
  HistoricalTransactioninquiry (params) {
    const url = URL.HistoricalTransactioninquiry.retrieve

    return axios.post(url, params)
  }
  /**
   *历史成交详情
   * @param {*} params
   */
  HistoricalTransactionXQ (params) {
    const url = URL.HistoricalTransactionXQ.retrieve

    return axios.post(url, params)
  }
  /**
   *当日成交明细
   * @param {*} params
   */
  TransactionDetail (params) {
    const url = URL.TransactionDetail.retrieve

    return axios.post(url, params)
  }
  /**
   *历史成交明细
   * @param {*} params
   */
  HistoricalTransactionDetail (params) {
    const url = URL.HistoricalTransactionDetail.retrieve

    return axios.post(url, params)
  }

  /**
   *当日套利成交汇总
   * @param {*} params
   */
  ArbitrageTransactionInquiry (params) {
    const url = URL.ArbitrageTransactionInquiry.retrieve

    return axios.post(url, params)
  }
  /**
   *当日套利成交详情
   * @param {*} params
   */
  ArbitrageTransactionDetail (params) {
    const url = URL.ArbitrageTransactionDetail.retrieve

    return axios.post(url, params)
  }
  /**
   *历史套利成交汇总
   * @param {*} params
   */
  HistoricalArbitrageTransactionInquiry (params) {
    const url = URL.HistoricalArbitrageTransactionInquiry.retrieve

    return axios.post(url, params)
  }
  /**
   *历史套利成交详情
   * @param {*} params
   */
  HistoricalArbitrageTransactionDetail (params) {
    const url = URL.HistoricalArbitrageTransactionDetail.retrieve

    return axios.post(url, params)
  }
  /**
   *当日套利成交明细
   * @param {*} params
   */
  ArbitrageTransactionDetailInquiry (params) {
    const url = URL.ArbitrageTransactionDetailInquiry.retrieve

    return axios.post(url, params)
  }
  /**
   *历史套利成交明细
   * @param {*} params
   */
  HistoricalArbitrageTransactionDetailInquiry (params) {
    const url = URL.HistoricalArbitrageTransactionDetailInquiry.retrieve

    return axios.post(url, params)
  }
  /**
   *当日订货汇总
   * @param {*} params
   */
  OrderInquiry (params) {
    const url = URL.OrderInquiry.retrieve

    return axios.post(url, params)
  }
  /**
   *历史订货汇总详情/历史套利订货汇总详情
   *type：'P';  P表示普通，T表示套利
   * @param {*} params
   */
  HistoricalOrderXQ (params) {
    const url = URL.HistoricalOrderXQ.retrieve

    return axios.post(url, params)
  }
  /**
   *当日订货汇总详情/当日套利订货汇总详情
   *type：'P';  P表示普通，T表示套利
   * @param {*} params
   */
  OrderXQ (params) {
    const url = URL.OrderXQ.retrieve

    return axios.post(url, params)
  }
  /**
   *历史订货汇总
   * @param {*} params
   */
  HistoricalOrderInquiry (params) {
    const url = URL.HistoricalOrderInquiry.retrieve

    return axios.post(url, params)
  }
  /**
   *当日订货明细
   * @param {*} params
   */
  OrderDetailInquiry (params) {
    const url = URL.OrderDetailInquiry.retrieve

    return axios.post(url, params)
  }
  /**
   *历史订货明细
   * @param {*} params
   */
  HistoricalOrderDetailInquiry (params) {
    const url = URL.HistoricalOrderDetailInquiry.retrieve

    return axios.post(url, params)
  }
  /**
   *当日套利订货汇总
   * @param {*} params
   */
  ArbitrageOrderInquiry (params) {
    const url = URL.ArbitrageOrderInquiry.retrieve

    return axios.post(url, params)
  }
  /**
   *历史套利订货汇总
   * @param {*} params
   */
  HistoricalArbitrageOrderInquiry (params) {
    const url = URL.HistoricalArbitrageOrderInquiry.retrieve

    return axios.post(url, params)
  }
  /**
   *当日套利订货明细
   * @param {*} params
   */
  ArbitrageOrderDetailInquiry (params) {
    const url = URL.ArbitrageOrderDetailInquiry.retrieve

    return axios.post(url, params)
  }
  /**
   *历史套利订货明细
   * @param {*} params
   */
  HistoricalArbitrageOrderDetailInquiry (params) {
    const url = URL.HistoricalArbitrageOrderDetailInquiry.retrieve

    return axios.post(url, params)
  }
  /**
   *交收汇总
   * @param {*} params
   */
  SettlementInquiry (params) {
    const url = URL.SettlementInquiry.retrieve

    return axios.post(url, params)
  }
  /**
   *交收汇总详情
   * @param {*} params
   */
  SettlementXQ (params) {
    const url = URL.SettlementXQ.retrieve

    return axios.post(url, params)
  }
  /**
   *历史交收汇总
   * @param {*} params
   */
  HistoricalSettlementInquiry (params) {
    const url = URL.HistoricalSettlementInquiry.retrieve

    return axios.post(url, params)
  }
  /**
   *历史交收汇总详情
   * @param {*} params
   */
  HistoricalSettlementXQ (params) {
    const url = URL.HistoricalSettlementXQ.retrieve

    return axios.post(url, params)
  }
  /**
   *交收明细
   * @param {*} params
   */
  SettlementDetailInquiry (params) {
    const url = URL.SettlementDetailInquiry.retrieve

    return axios.post(url, params)
  }
  /**
   *历史交收明细
   * @param {*} params
   */
  HistoricalSettlementDetailInquiry (params) {
    const url = URL.HistoricalSettlementDetailInquiry.retrieve

    return axios.post(url, params)
  }
  /**
   *获取token
   * @param {*} params
   */
  getToken () {
    const url = URL.GoodsPayment.getToken
    const memberNumber = JSON.parse(localStorage.getItem('pro__USER_INFO')).value.account
    const param = {
      memberNumber: memberNumber
    }
    return axios.post(url, param)
  }
  /**
   *获取所有主体列表
   * @param {*} params
   */
  getAllCompany (param) {
    const url = URL.GoodsPayment.getAllCompany
    return axios.post(url, { token: param.token })
  }
  /**
   *交收办理查询
   * @param {*} params
   */
  transactDataList (param) {
    const url = URL.GoodsPayment.transactData

    return axios.post(url, param)
  }
  /**
   *到期/提前交收通知单
   * @param {*} params
   */
  getReceiptData (param) {
    const url = URL.GoodsPayment.getReceiptData

    return axios.post(url, param)
  }
  /**
   *交易费用
   * @param {*} params
   * isTradeDay 是否当天交易日（0 当天 1 历史 ）
   */
  TransactionCostInquiry (params) {
    const url = URL.TransactionCostInquiry.retrieve

    return axios.post(url, params)
  }
  /**
   *当前盈亏明细
   * @param {*} params
   */
  HreakevenDetailsInquiry (params) {
    const url = URL.HreakevenDetailsInquiry.retrieve

    return axios.post(url, params)
  }
  /**
   *当前盈亏明细
   * @param {*} params
   */
  HreakevenDetailsDetail (params) {
    const url = URL.HreakevenDetailsInquiry.detail

    return axios.post(url, params)
  }
  /**
   *历史盈亏明细
   * @param {*} params
   */
  HistoricalHreakevenDetailsInquiry (params) {
    const url = URL.HistoricalHreakevenDetailsInquiry.retrieve

    return axios.post(url, params)
  }
  /**
   *历史盈亏明细
   * @param {*} params
   */
  HistoricalHreakevenDetailsDetail (params) {
    const url = URL.HistoricalHreakevenDetailsInquiry.detail

    return axios.post(url, params)
  }
  /**
   *购销计划一览表-当日行情表
   * @param {*} params
   */
  DailyQuotationSheet (params) {
    const url = URL.DailyQuotationSheet.retrieve

    return axios.post(url, params)
  }
  /**
   *购销计划一览表-基本担保履约资金帐户日报表
   * @param {*} params
   */
  DailyStatementOfCapitalAccount (params) {
    const url = URL.DailyStatementOfCapitalAccount.retrieve

    return axios.post(url, params)
  }
  /**
   *成交汇总
   * @param {*} params
   */
  TransactionSummary (params) {
    const url = URL.TransactionSummary.retrieve

    return axios.post(url, params)
  }
  /**
   *成交明细
   * @param {*} params
   */
  TransactionDetails (params) {
    const url = URL.TransactionDetails.retrieve

    return axios.post(url, params)
  }
  /**
   *套利成交明细
   * @param {*} params
   */
  ArbitrageTransactionDetails (params) {
    const url = URL.ArbitrageTransactionDetails.retrieve

    return axios.post(url, params)
  }
  /**
   *订货汇总
   * @param {*} params
   */
  OrderSummary (params) {
    const url = URL.OrderSummary.retrieve

    return axios.post(url, params)
  }
  /**
   *订货明细
   * @param {*} params
   */
  OrderDetail (params) {
    const url = URL.OrderDetail.retrieve

    return axios.post(url, params)
  }
  /**
   *当日按购销计划查订货
   * @param {*} params
   */
  QueryGoodsCodeCurrentPositions (params) {
    const url = URL.QueryGoodsCodeCurrentPositions.retrieve

    return axios.post(url, params)
  }
  /**
   *历史按购销计划查订货
   * @param {*} params
   */
  QueryGoodsCodeHisPositions (params) {
    const url = URL.QueryGoodsCodeHisPositions.retrieve

    return axios.post(url, params)
  }
  // 套利订货明细
  ArbitrageOrderDetail (params) {
    const url = URL.ArbitrageOrderDetail.retrieve

    return axios.post(url, params)
  }
  // 月成交汇总
  MonthlyClosingSummary (params) {
    const url = URL.MonthlyClosingSummary.retrieve

    return axios.post(url, params)
  }
  // 月持仓汇总查询
  MonthlyPositionSummary (params) {
    const url = URL.MonthlyPositionSummary.retrieve

    return axios.post(url, params)
  }
  // 月历史诚意金查询
  MonthlyHistoricalSincerityGold (params) {
    const url = URL.MonthlyHistoricalSincerityGold.retrieve

    return axios.post(url, params)
  }
  // 查询用户当前市场信息
  MarketInfo (params) {
    const url = URL.MarketInfo.retrieve

    return axios.post(url, params)
  }
  // 货款账户日报表
  dailyStatementDataList (param) {
    const url = URL.GoodsPayment.dailyStatementDataList

    return axios.post(url, param)
  }
  // 获取暂扣款项列表
  withholdingPaymentList (param) {
    const url = URL.GoodsPayment.withholdingPayment

    return axios.post(url, param)
  }
  // 货款账户
  paymentList (param) {
    const url = URL.GoodsPayment.paymentList

    return axios.post(url, param)
  }
  // 交易日
  SelTradeDate (param) {
    const url = URL.SelTradeDate.retrieve

    return axios.post(url, param)
  }
}

export default new SpotPurchaseSale()
